type ValidationResult<T> =
  | { isValid: true; error: null }
  | { isValid: false; error: T };

export enum AnimalCategoryError {
  Required,
}

export function validateAnimalCategory(
  animalCategoryId: number | null
): ValidationResult<AnimalCategoryError> {
  if (animalCategoryId == null) {
    return { isValid: false, error: AnimalCategoryError.Required };
  }

  return { isValid: true, error: null };
}

export enum OperationTypeError {
  Required,
}

export function validateOperationType(
  operationTypeId: number | null
): ValidationResult<OperationTypeError> {
  if (operationTypeId == null) {
    return { isValid: false, error: OperationTypeError.Required };
  }

  return { isValid: true, error: null };
}

export enum OperationDateError {
  Required,
}

export function validateOperationDate(
  operationDate: string | null
): ValidationResult<OperationDateError> {
  if (operationDate == null) {
    return { isValid: false, error: OperationDateError.Required };
  }

  return { isValid: true, error: null };
}

export enum QuantityError {
  Required,
}

export function validateQuantity(
  quantity: number | null
): ValidationResult<QuantityError> {
  if (quantity == null) {
    return { isValid: false, error: QuantityError.Required };
  }

  return { isValid: true, error: null };
}

export enum RecordTypeError {
  Required,
}

export function validateRecordType(
  recordTypeId: number | null
): ValidationResult<RecordTypeError> {
  if (recordTypeId == null) {
    return { isValid: false, error: RecordTypeError.Required };
  }

  return { isValid: true, error: null };
}

export enum WeightError {
  Required,
}

export function validateWeight(
  weight: number | null
): ValidationResult<WeightError> {
  if (weight == null) {
    return { isValid: false, error: WeightError.Required };
  }

  return { isValid: true, error: null };
}

export enum CarcassYieldError {
  OutOfRange,
}

export function validateCarcassYield(
  carcassYield: number | null
): ValidationResult<CarcassYieldError> {
  if (carcassYield == null) {
    return { isValid: true, error: null };
  }

  if (carcassYield < 0 || carcassYield > 100) {
    return { isValid: false, error: CarcassYieldError.OutOfRange };
  }

  return { isValid: true, error: null };
}
